enum EPersonalAreaTabs {
  LOBBY = 'lobby',
  PERSONAL_DETAILS = 'personalDetails',
  SUBSCRIPTIONS = 'subscriptions',
  PURCHASE_HISTORY = 'purchaseHistory',
  FAMILY_AND_FRIENDS = 'familyAndFriends',
  MY_MERCHANDISE = 'myMerchandise',
  THE_RED_CLUB = 'theRedClub',
}

export { EPersonalAreaTabs }
